import { Component, OnInit } from "@angular/core";
// import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeHtml, SafeResourceUrl } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";

import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";

import { environment } from "../../../environments/environment";
import { ApiHelper } from "../../_helpers/api.helper";
import { CommonHelper } from "../../_helpers/common.helper";
import { ConstantHelper } from "../../_helpers/constant.helper";
import { AppConfig } from "../../app.config";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { Subject } from "rxjs";
import * as XLSX from 'xlsx';
import { ClassGetter } from "@angular/compiler/src/output/output_ast";

interface UserData {
  fullName: string;
  mobile: string;
  email: string;
  docId: number;
}
interface TemplateVariable {
  label: string;
  value: string;
}
interface CategorizedVariableGroup {
  category: string;
  items: TemplateVariable[];
}
@Component({
  selector: "app-admin-upload-template",
  templateUrl: "./admin-upload-template.component.html",
  styleUrls: ["./admin-upload-template.component.scss"],
  providers: [AppConfig, CommonHelper],
})
export class AdminUploadTemplateComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  loggedInUserId: string;

  comapnyName: string = ConstantHelper.COMPANY_NAME;
  childRoute: string;
  groupsList: any = [];
  groupsLength = false;
  addAdminObj: any = {};
  userAdded = false;
  existingMobile = false;
  existingEmail = false;
  invitePatientLogsList: any = [];
  newUser: any = [];
  ExistingUser: any = [];
  registeredUser: any = [];
  dataSource: any;
  bulkPatientApiData: any;
  bulkPatientApiDataFlag: boolean = false;
  fileUploaded: boolean = false;
  private uploadTemplateUrl = this.appConfig.getTranscribeApiUrl();

  // documentGroups: string[] = []; 
  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  message = Message;
  showLoader = false;
  userList: UserData[] = [];
  file: File | null = null;
  rawData: any;
  patientData: any = [];
  showHtmlModal = false;
  selectedFile: File | null = null;
  generatedHtml: string = '';
  templateName: string = '';
  currentTemplateType: string = '';
  activeTemplateType: string = '';
  loadingTemplateType: string = '';
  showPreviewModal = false;
  sanitizedHtml: SafeHtml = '';
  showVariablesModal = false;
  selectedTemplateType: string = '';
  templateVariables: { label: string; value: string }[] = [];
  categorizedVariables: CategorizedVariableGroup[] = [];
  expandedSections: { [key: string]: boolean } = {}; // Track expanded state by category
  templateTypes: string[] = ['follow-up', 'prescription', 'appointment']; // initial rows
  selectedFileMap: { [key: string]: File | null } = {};
  templateList: any[] = [];
  //selectedFiles: { [id: number]: File } = {};
  selectedFiles: { [key: number]: File } = {}; // use object, not array
  shareRoles: string[] = [];
  roleSelections: { [key: string]: boolean } = {};
  selectedTemplateId: number | null = null;
  showShareModal = false;
  searchKeyword: string = '';
  showAddTemplateModal: boolean = false;
  newTemplateName: string = '';

  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    public sweetAlertHelper: SweetAlertHelper,
    private sanitizer: DomSanitizer
  ) {
    // console.log(activatedRoute.snapshot.url); // array of states
    localStorage.setItem("childRoute", activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
  }

  ngOnInit() {
    this.dtOptions = {
      order: [],
    };
    this.addAdminObj.DocGroupId = "";
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.getTemplateList();
  }

  async goToDemographics() {
    // const alertStatus = await this.sweetAlertHelper.confirmPopUp(
    //   this.message.confirmTitle,
    //   this.message.confirmMessages.adminUploaddocComp.gotoDemgraphics
    // );
    // if (alertStatus) {
    this.router.navigate([
      "/" + this.childRoute + "/demographics/" + this.loggedInUserId + "/0",
    ]);
    // }
  }

  //    onFileSelected(event: any) {
  //   const file = event.target.files[0];
  //   if (file && file.name.endsWith('.docx')) {
  //     this.selectedFile = file;
  //   } else {
  //     alert('Please upload a valid .docx file.');
  //     this.selectedFile = null;
  //   }
  // }

  onFileSelected(event: Event, templateId: number): void {
   // alert("upload")
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles[templateId] = input.files[0];
    }
  }

  getFilteredItems(group: any): any[] {
   if (!this.searchKeyword || this.searchKeyword.trim() === '') {
    return[];
   }
  const keyword = this.searchKeyword.toLowerCase();
  return group.items.filter((item: any) =>
    item.label.toLowerCase().includes(keyword) ||
    item.value.toLowerCase().includes(keyword)
  );
}

hasMatchingResults(): boolean {
  return this.categorizedVariables.some(group =>
    this.getFilteredItems(group).length > 0
  );
}

openAddTemplateModal(): void {
  this.newTemplateName = '';
  this.showAddTemplateModal = true;
}

closeAddTemplateModal(): void {
  this.showAddTemplateModal = false;
}

  addTemplateRow(): void {
    // const name = prompt('Enter a template name:');
    // if (!name) return;
    // const cleanName = name.trim(); // Keep original case & hyphens
    // const payload = { template_name: cleanName };

    // console.log('Sending to backend:', payload);    
    const name = this.newTemplateName.trim();
  if (!name) {
    // alert('Template name is required.');
    this.sweetAlertHelper.alertPopUp('Template name is required.');
    return;
  }

  const payload = { template_name: name };
  console.log('Sending to backend:', payload);

    this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.saveTemplate, payload).subscribe({
      next: (res: any) => {
        if (res && res.commandResult && res.commandResult.status === 1) {          
          // alert('Template saved successfully!');
          this.sweetAlertHelper.alertPopUp('Template saved successfully!');
          this.showAddTemplateModal = false;
          this.getTemplateList(); 
        } else {
          alert('Failed to save template. Please try again.');
        }
      },
      error: (err) => {
        console.error(err);
        alert('An error occurred while saving the template.');
      }
    });
  }


  getTemplateList() {
    this.http
      .post(
        this.appConfig.getLambdaUrl05() + ApiHelper.getTemplates,
        {}, // pass empty object or payload if needed
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          if (
            res && res.commandResult &&
            res.commandResult.status === 1 &&
            Array.isArray(res.commandResult.data)
          ) {
            this.templateList = res.commandResult.data;
            console.log("template details: ", this.templateList)
            const sample = this.templateList[0];
            if (sample) {
              // Extract all role fields dynamically
              this.shareRoles = Object.keys(sample).filter(
                key =>
                  typeof sample[key] === 'number' &&
                  !['id', 'template_name', 'status'].includes(key)
              );
            }
          } else {
            console.warn('Unexpected response format:', res);
          }
        },
        (error) => {
          console.error('API error:', error);
        }
      );
  }



  openShareModal(template: any) {
    this.selectedTemplateId = template.id;
    this.roleSelections = {};

    this.shareRoles.forEach(role => {
      this.roleSelections[role] = template[role] === 1;
    });

    this.showShareModal = true;
  }

 saveShareRoles() {
  const payload = {
    id: this.selectedTemplateId,
    roles: this.roleSelections
  };
  console.log("payload...",payload)
  this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.updateShareRoles, payload).subscribe({
    next: (res: any) => {
      if (res && res.commandResult && res.commandResult.status === 1) {
        alert("Record updated successfully!!");
      } else {
        alert("Failed");
      }
    },
    error: (err) => {
      console.error(err);
      alert("Error updating roles");
    }
  }); // ✅ This closing parenthesis and semicolon was likely missing
} // ✅ This closing brace may have been missing



  generateHTML(templateName: string, templateId: number) {
    const file = this.selectedFiles[templateId];
    if (!file) {
      console.warn("No file selected for template:", templateId);
      return;
    }
    this.activeTemplateType = templateName;
    this.loadingTemplateType = templateName;
    const formData = new FormData();
    formData.append('file', file);

    // this.http.post('http://localhost:5000/upload-docs', formData, { responseType: 'text' }).subscribe({
      this.http.post(this.uploadTemplateUrl+"upload-docs", formData, { responseType: 'text' }).subscribe({
      next: (response) => {
        this.generatedHtml = response;
        // this.generatedHtml = this.generatedHtml.replace(/{|}/g, '').replace(/```/g, '')    
        this.currentTemplateType = templateName;
        localStorage.setItem("html_template", this.generatedHtml)
        this.showHtmlModal = true;
        this.loadingTemplateType = '';
      },

      error: (err) => {
        console.error('Error generating HTML:', err);
        alert('Failed to generate HTML from the document.');
        this.loadingTemplateType = '';
      }

    });
    console.log("html template: ", this.generatedHtml)
  }

  closeHtmlModal() {
    this.showHtmlModal = false;
  }
  async saveTemplate() {
    if (!this.templateName.trim()) {
      alert('Please enter a valid file name.');
      return;
    }

    // Determine folder name logic
    let folderName = '';
    if (this.currentTemplateType === 'prescription') {
      folderName = 'prescription_temp';
    } else if (this.currentTemplateType === 'appointment') {
      folderName = 'appointment_temp';
    } else if (this.currentTemplateType === 'follow-up') {
      folderName = 'follow_up_temp';
    } else {
      folderName = this.activeTemplateType;
    }

    const filename = this.templateName.endsWith('.html')
      ? this.templateName
      : `${this.templateName}.html`;
    this.generatedHtml = String(this.generatedHtml || '').replace(/```html/g, "").replace(/```/g, "").trim();
    const fullHtml = this.generatedHtml.includes('<html')
      ? this.generatedHtml
      : `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>${filename}</title>
</head>
<body>
${this.generatedHtml}
</body>
</html>`;

    try {
      const payload = {
        filename: filename,
        html: fullHtml,
        folderName: folderName
      };

      // const response: any = await this.http.post('http://localhost:5000/save-template', payload).toPromise();
      const response: any = await this.http.post(this.uploadTemplateUrl+"save-template", payload).toPromise();
      if (response) {
        alert(`Template saved successfully!\n\nFilename: ${response.filename}\nPath: ${response.path}`);
        this.showHtmlModal = false;
        window.location.reload();
      } else {
        alert('Template saved, but no information returned.');
      }

    } catch (err) {
      console.error('Error saving template:', err);
      alert('Failed to save the template.');
    }
  }

  PreviewTemplate() {
    // this.showPreviewModal = true; 
    const newTab = window.open('', '_blank');
    if (newTab) {
      newTab.document.open();
      console.log("html code", this.generatedHtml)
      newTab.document.write(this.generatedHtml);
      newTab.document.close();
    } else {
      alert('Popup blocked! Please allow popups for this site.');
    }
  }

  closePreviewModal() {
    this.showPreviewModal = false;
  }



  getTemplate(templateType: string) {    
    // Map templateType to folder name
    let folderName = '';
    if (templateType === 'Prescription') {
      folderName = 'prescription_temp';
    } else if (templateType === 'Appointment') {
      folderName = 'appointment_temp';
    } else if (templateType === 'Follow-Up') {
      folderName = 'follow_up_temp';
    } else {
      // alert('Unknown template type');
      this.sweetAlertHelper.alertPopUp('Template Not Available for Preview... Please Generate the template and save it')
      return;
    }

    const formData = new FormData();
    formData.append('templateName', templateType);
    formData.append('folderName', folderName);

    // this.http.post('http://localhost:5000/get-latest-template', formData, { responseType: 'text' }).subscribe({
    this.http.post(this.uploadTemplateUrl + "get-latest-template", formData, { responseType: 'text' }).subscribe({
      next: (response: string) => {
        const newWindow = window.open('', '_blank');
        if (newWindow) {
          newWindow.document.open();
          newWindow.document.write(response); // Insert the HTML content
          newWindow.document.close();
        } else {
          alert('Popup blocked. Please allow popups for this website.');
        }
      },
      error: (err) => {
        console.error('Error loading template:', err);
        alert('Failed to load the latest template.');
      }
    });
  }

  toggleStatus(template: any): void {
    const newStatus = template.status === 1 ? 0 : 1;

    const payload = {
      id: template.id,
      status: newStatus
    };

    this.http.post(this.appConfig.getLambdaUrl05() + ApiHelper.updateTemplateStatus, payload).subscribe({
      next: (res: any) => {
        if (res && res.commandResult && res.commandResult.status === 1) {
          template.status = newStatus; // Reflect updated status immediately
        } else {
          alert('Failed to update status.');
        }
      },
      error: (err) => {
        console.error('Error updating status:', err);
        alert('An error occurred while updating status.');
      }
    });
  }


  showVariables(): void {
    this.categorizedVariables = [
      {
        category: 'Patient Details',
        items: [
          { label: 'Patient Name', value: '[patient_name]' },
          { label: 'Patient Phone', value: '[phone]' },
          { label: 'Patient Email', value: '[email]' },
          { label: 'Patient DOB', value: '[dob]' }
        ]
      },
      {
        category: 'Physician Details',
        items: [
          { label: 'Doctor Name', value: '[doctor_name]' },
          { label: 'Doctor Email', value: '[email]' },
          { label: 'Doctor Phone', value: '[phone]' }
        ]
      },
      {
        category: 'Pharmacy/Medication',
        items: [
          { label: 'Medication Name', value: '[name]' },
          { label: 'Dosage', value: '[dosage]' },
          { label: 'Route', value: '[route]' },
          { label: 'Frequency', value: '[frequency]' },
          { label: 'Purpose', value: '[purpose]' }
        ]
      },
      {
        category: 'Appointment Info',
        items: [
          { label: 'Practice Name', value: '[clinic_name]' },
          { label: 'Appointment Confirmation Date', value: '[confirmationDate]' },
          { label: 'Appointment Date & Time', value: '[appointmentDateTime]' },
          { label: 'Instructions', value: '[instructions]' }
        ]
      },
      {
        category: 'Follow-Up Info',
        items: [
          { label: 'Reason for Visit', value: '[reason_for_visit]' },
          { label: 'Clinical Notes', value: '[clinical_notes]' },
          { label: 'Instructions', value: '[instructions]' },
          { label: 'Next Follow-up', value: '[next_followup]' }
        ]
      }
    ];

    // Initialize all sections as collapsed
    this.expandedSections = {};
    for (const group of this.categorizedVariables) {
      this.expandedSections[group.category] = false;
    }

    this.showVariablesModal = true;
  }

  toggleSection(category: string): void {
    this.expandedSections[category] = !this.expandedSections[category];
  }

  closeVariablesModal(): void {
    this.showVariablesModal = false;
  }


}
